import React, { useState } from "react";
import toast from 'react-hot-toast';
import NumberInput from './NumberInput';
import { getKoreanToday } from '../utils/dateUtils';
import { BOOK_STATUS, BOOK_STATUS_LIST } from '../constants/bookStatus';

const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="label">{label}</span>
    {hint && (
      <span className="ml-2 text-[11px] text-ink-500 dark:text-ink-400 font-sans normal-case tracking-normal">
        {hint}
      </span>
    )}
    <div className="mt-2">{children}</div>
  </label>
);

/** 검색으로 찾을 수 없는 책을 직접 입력해 추가한다 */
const AddBookForm = ({ onAddBook }) => {
  const [form, setForm] = useState({
    title: '',
    author: '',
    totalPages: '',
    currentPage: '',
    startDate: getKoreanToday(),
    imageUrl: '',
    status: BOOK_STATUS.READING
  });
  const [saving, setSaving] = useState(false);

  const set = (key) => (e) => setForm(prev => ({ ...prev, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    const totalPages = parseInt(form.totalPages, 10);
    const initialPage = form.currentPage ? parseInt(form.currentPage, 10) : 0;

    if (!form.title.trim() || !form.author.trim() || !Number.isFinite(totalPages)) {
      toast.error('제목, 저자, 전체 페이지는 필수예요');
      return;
    }
    if (initialPage > totalPages) {
      toast.error('이미 읽은 쪽수가 전체보다 많을 수 없어요');
      return;
    }

    setSaving(true);
    try {
      await onAddBook({
        title: form.title.trim(),
        author: form.author.trim(),
        totalPages,
        initialPage,
        startDate: form.startDate,
        imageUrl: form.imageUrl.trim(),
        status: form.status
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <Field label="제목">
        <input type="text" value={form.title} onChange={set('title')} className="field" />
      </Field>

      <Field label="저자">
        <input type="text" value={form.author} onChange={set('author')} className="field" />
      </Field>

      <div className="grid grid-cols-2 gap-4">
        <Field label="전체 페이지">
          <NumberInput
            min="1"
            value={form.totalPages}
            onChange={set('totalPages')}
          />
        </Field>
        <Field label="이미 읽은 쪽">
          <NumberInput
            min="0"
            value={form.currentPage}
            onChange={set('currentPage')}
            placeholder="0"
          />
        </Field>
      </div>

      <Field label="시작일">
        <input type="date" value={form.startDate} onChange={set('startDate')} className="field" />
      </Field>

      <Field label="표지 이미지 URL" hint="선택 · 인터넷 서점에서 이미지 주소 복사">
        <input
          type="url"
          value={form.imageUrl}
          onChange={set('imageUrl')}
          placeholder="https://..."
          className="field break-all"
        />
      </Field>

      <div>
        <span className="label">독서 상태</span>
        <div className="mt-2 flex flex-wrap gap-2">
          {BOOK_STATUS_LIST.map(s => (
            <button
              key={s.value}
              type="button"
              onClick={() => setForm(prev => ({ ...prev, status: s.value }))}
              className={`chip ${form.status === s.value ? 'chip-active' : ''}`}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <button
        type="submit"
        disabled={saving}
        className="btn-primary w-full disabled:opacity-40"
      >
        {saving ? '추가 중...' : '서재에 담기'}
      </button>
    </form>
  );
};

export default AddBookForm;
